import React from 'react';

export type FormContextType = {
  disabled?: boolean;
};

let FormContext = React.createContext<FormContextType | null>(null);
export default FormContext;
